import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamChannelsFieldConfig } from '../shared/models/generated/ziroModels';

@Injectable({ providedIn: 'root' })
export class TeamsCallQueueChannelsResource {
  private _httpClient = inject(HttpClient);

  get(tenantId: string, teamId: string): Observable<MicrosoftTeamChannelsFieldConfig> {
    return this._httpClient.get<MicrosoftTeamChannelsFieldConfig>(
      `/services/microsoft/call-queue-management/tenants/${tenantId}/teams/${encodeURIComponent(teamId)}/channels`,
    );
  }
}
